// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cac18545","498":"a487f5c1","703":"828ce310","787":"25b6f668"}[chunkId] + ".chunk.js";
};